export const required = [(value: any) => !!value || "Tidak boleh kosong."];
export const maxLength = (max: number) => [(value: any) => value && value.length <= max || `Max ${max} karakter`];
export const maxFileSize = (max: number = 2) => [
    (value: any) => !value || value.size < max * 1000000 || `Max ${max} mb`,
  ];
export const noSpace = [
  (value: any) => value && !!value.trim() || "Tidak boleh kosong.",
  (value: any) => value && value.split(' ').length <= 1 || "Tidak boleh menggunakan spasi"
]